import { LegacyOttTrailerPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';

export function useReadMovieTrailerPlayerBaseInfo(
    contentId: string
): LegacyOttTrailerPlayerBaseInfoContent | undefined {
    const data = useReadPlayerBaseInfo(contentId);

    if (data?.content?.__typename === 'OttTrailer') {
        return data.content;
    }

    return undefined;
}
